import styled from "styled-components";
import {Fab} from "@material-ui/core";

const getCircleButtonColor = (color?: string) => {
    switch (color) {
        case "red": return "#a94747";
        case "green": return "#0c995e";
        case "orange": return "#de9e27";
        case "gray": return "#808080";
        default: return "#228dc7";
    }
}

export const IconCircle = styled(Fab)`
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  background-color: ${(props: { color: any; }) => `${getCircleButtonColor(props.color)}20`} !important;
  box-shadow: none !important;
    opacity: 0.8 !important;
    transform: scale(0.8);
  
    svg {
      color: ${(props: { color: any; }) => getCircleButtonColor(props.color)};
        font-size: 1.6rem !important;
    }
`;